export default __webpack_public_path__ + "static/media/hotlineit.f967ba96.jpg";